export default "__VITE_ASSET__WMhPOxZ5__"